﻿package com.mgacreative.hotelru.feature.reservation.ui.checkout

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotelru.core.network.SupabaseNetworkClient
import com.mgacreative.hotelru.feature.reservation.data.FolioRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import com.mgacreative.hotelru.domain.repository.ReservationRepository
import com.mgacreative.hotelru.core.tenant.TenantSession
import io.github.jan.supabase.postgrest.postgrest

data class FolioItem(val name: String, val price: Double)
data class CheckoutSummary(
    val nights: Int = 3,
    val roomRate: Double = 150.0,
    val extras: List<FolioItem> = emptyList(),
    val total: Double = 0.0
)

class CheckOutViewModel(
    private val reservationRepository: ReservationRepository,
    private val supabaseClient: SupabaseNetworkClient,
    private val tenantSession: TenantSession
) : ViewModel() {
    private val _summary = MutableStateFlow(CheckoutSummary())
    val summary: StateFlow<CheckoutSummary> = _summary.asStateFlow()

    private val _checkOuts = MutableStateFlow<List<CheckOutItemData>>(emptyList())
    val checkOuts: StateFlow<List<CheckOutItemData>> = _checkOuts.asStateFlow()

    fun loadTodayCheckOuts() {
        viewModelScope.launch {
            try {
                val allReservations = reservationRepository.getReservations()
                // Yalnızca durumu CHECKED_IN olanları Check-Out için göster
                val checkedInList = allReservations.filter { it.status == "CHECKED_IN" }
                
                _checkOuts.value = checkedInList.map { res ->
                    CheckOutItemData(
                        id = res.id ?: "",
                        guestName = res.guests?.firstName + " " + res.guests?.lastName,
                        rooms = listOf(res.rooms?.roomNumber ?: res.roomId ?: res.roomType ?: "Belirsiz"),
                        dateRange = "${res.checkInDate} - ${res.checkOutDate}"
                    )
                }
            } catch (e: Exception) {
                // Handle error
            }
        }
    }

    fun loadFolio(reservationId: String) {
        viewModelScope.launch {
            try {
                val tenantId = tenantSession.currentTenantId ?: return@launch
                
                @kotlinx.serialization.Serializable
                data class DbFolioItem(
                    val category: String,
                    val description: String,
                    val amount: Double
                )
                
                val dynamicExtras = supabaseClient.client.postgrest["folio_items"]
                    .select {
                        filter {
                            eq("tenant_id", tenantId)
                            eq("reservation_id", reservationId)
                        }
                    }
                    .decodeList<DbFolioItem>()
                    .map { FolioItem(it.description, it.amount) }
                
                val allExtras = dynamicExtras
                
                val nights = 3
                val roomRate = 150.0
                val total = (nights * roomRate) + allExtras.sumOf { it.price }
                
                _summary.value = CheckoutSummary(nights, roomRate, allExtras, total)
            } catch (e: Exception) {
                e.printStackTrace()
            }
        }
    }

    fun completeCheckOut(roomId: String, invoiceAmount: Double) {
        viewModelScope.launch {
            try {
                // Generate Invoice
                // Mark Room as CLEANING
            } catch (e: Exception) {}
        }
    }

    fun addManualFolioItem(reservationId: String, name: String, amount: Double) {
        viewModelScope.launch {
            try {
                val tenantId = tenantSession.currentTenantId ?: return@launch
                @kotlinx.serialization.Serializable
                data class FolioItemRequest(
                    val tenant_id: String,
                    val reservation_id: String,
                    val category: String,
                    val description: String,
                    val amount: Double
                )
                
                supabaseClient.client.postgrest["folio_items"].insert(
                    FolioItemRequest(
                        tenant_id = tenantId,
                        reservation_id = reservationId,
                        category = "OTHER",
                        description = name,
                        amount = amount
                    )
                )
                // Reload folio
                loadFolio(reservationId)
            } catch (e: Exception) {
                e.printStackTrace()
            }
        }
    }
}

// UI State Model
data class CheckOutItemData(
    val id: String,
    val guestName: String,
    val rooms: List<String>,
    val dateRange: String
)


